import chooseApi from '../api/choose';


export const getValidCoupons = params => {
	const {cityId, userId, lineId} = params || {};
	if (!cityId || !userId || !lineId) {
    return Promise.reject({
      msg: '暂无可用优惠券。',
      list: []
    })
  }
	return chooseApi.list(params);
};
